import ImageGallery from '../../../../CodeQ.Site/Resources/Private/Fusion/Presentation/Molecule/ImageGallery/ImageGallery.js';

export default class AssetGallery extends ImageGallery { // uses splideCreate method from ImageGallery
    static init() {
        Array.from(document.querySelectorAll('.asset-gallery')).forEach(element => {
            new AssetGallery(element);
        });
    }

    // tslint:disable-next-line
    constructor(element) {
        super();

        this.directionsld = 'right';
        const lightboxSplide = this.splideCreate(element.querySelector('.image-gallery__lightbox-splide'));

        // on gallery click, open the lightbox
        element.querySelector('.card-grid').addEventListener('click', (e) => {
            debugger;
            const contentImage = e.target && e.target.closest('.asset-gallery__item-media');
            if(contentImage) {
                const lightboxElement = e.target.closest('.asset-gallery').querySelector('.innsbruck-lightbox');
                const event = new Event('openLightbox', {bubbles: true});
                lightboxElement.dispatchEvent(event);
                lightboxSplide.go(contentImage.closest('.column').getAttribute('data-lightbox-index') * 1);
            }
        });
    }
}
